(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "3fcfb32de39a8c00a2691d86a11f5a75eb861ab2"
};